export const COUNTRY_CODE = {
  CA: '124',
  US: '840',
} as const

export const validateCountryCode = (country: string): boolean =>
  country === COUNTRY_CODE.CA || country === COUNTRY_CODE.US

export const isCanadaOrUSA = validateCountryCode

export const COUNTRIES = [
  { code: COUNTRY_CODE.CA, name: 'Canada' },
  { code: COUNTRY_CODE.US, name: 'United States' },
] as const

export const CANADIAN_PROVINCES = [
  {
    code: '09',
    name: 'Alberta',
    rcmpCode: 'AB',
    postalCode: 'AB',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '10',
    name: 'British Columbia',
    rcmpCode: 'BC',
    postalCode: 'BC',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '07',
    name: 'Manitoba',
    rcmpCode: 'MB',
    postalCode: 'MB',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '04',
    name: 'New Brunswick',
    rcmpCode: 'NK',
    postalCode: 'NB',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '01',
    name: 'Newfoundland And Labrador',
    rcmpCode: 'NF',
    postalCode: 'NL',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '03',
    name: 'Nova Scotia',
    rcmpCode: 'NS',
    postalCode: 'NS',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '11',
    name: 'North West Territories',
    rcmpCode: 'NT',
    postalCode: 'NT',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '13',
    name: 'Nunavut',
    rcmpCode: 'NU',
    postalCode: 'NU',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '06',
    name: 'Ontario',
    rcmpCode: 'ON',
    postalCode: 'ON',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '02',
    name: 'Prince Edward Island',
    rcmpCode: 'PE',
    postalCode: 'PE',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '05',
    name: 'Quebec',
    rcmpCode: 'PQ',
    postalCode: 'QC',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '08',
    name: 'Saskatchewan',
    rcmpCode: 'SN',
    postalCode: 'SK',
    countryCode: COUNTRY_CODE.CA,
  },
  {
    code: '12',
    name: 'Yukon',
    rcmpCode: 'YT',
    postalCode: 'YT',
    countryCode: COUNTRY_CODE.CA,
  },
] as const

export const US_STATES = [
  { code: '20', name: 'Alabama', stateCode: 'AL', countryCode: COUNTRY_CODE.US },
  { code: '21', name: 'Alaska', stateCode: 'AK', countryCode: COUNTRY_CODE.US },
  { code: '22', name: 'Arizona', stateCode: 'AZ', countryCode: COUNTRY_CODE.US },
  { code: '23', name: 'Arkansas', stateCode: 'AR', countryCode: COUNTRY_CODE.US },
  { code: '24', name: 'California', stateCode: 'CA', countryCode: COUNTRY_CODE.US },
  { code: '25', name: 'Colorado', stateCode: 'CO', countryCode: COUNTRY_CODE.US },
  { code: '26', name: 'Connecticut', stateCode: 'CT', countryCode: COUNTRY_CODE.US },
  { code: '27', name: 'Delaware', stateCode: 'DE', countryCode: COUNTRY_CODE.US },
  { code: '28', name: 'District of Columbia', stateCode: 'DC', countryCode: COUNTRY_CODE.US },
  { code: '29', name: 'Florida', stateCode: 'FL', countryCode: COUNTRY_CODE.US },
  { code: '30', name: 'Georgia', stateCode: 'GA', countryCode: COUNTRY_CODE.US },
  { code: '31', name: 'Hawaii', stateCode: 'HI', countryCode: COUNTRY_CODE.US },
  { code: '32', name: 'Idaho', stateCode: 'ID', countryCode: COUNTRY_CODE.US },
  { code: '33', name: 'Illinois', stateCode: 'IL', countryCode: COUNTRY_CODE.US },
  { code: '34', name: 'Indiana', stateCode: 'IN', countryCode: COUNTRY_CODE.US },
  { code: '35', name: 'Iowa', stateCode: 'IA', countryCode: COUNTRY_CODE.US },
  { code: '36', name: 'Kansas', stateCode: 'KS', countryCode: COUNTRY_CODE.US },
  { code: '37', name: 'Kentucky', stateCode: 'KY', countryCode: COUNTRY_CODE.US },
  { code: '38', name: 'Louisiana', stateCode: 'LA', countryCode: COUNTRY_CODE.US },
  { code: '39', name: 'Maine', stateCode: 'ME', countryCode: COUNTRY_CODE.US },
  { code: '40', name: 'Maryland', stateCode: 'MD', countryCode: COUNTRY_CODE.US },
  { code: '41', name: 'Massachusetts', stateCode: 'MA', countryCode: COUNTRY_CODE.US },
  { code: '42', name: 'Michigan', stateCode: 'MI', countryCode: COUNTRY_CODE.US },
  { code: '43', name: 'Minnesota', stateCode: 'MN', countryCode: COUNTRY_CODE.US },
  { code: '44', name: 'Mississippi', stateCode: 'MS', countryCode: COUNTRY_CODE.US },
  { code: '45', name: 'Missouri', stateCode: 'MO', countryCode: COUNTRY_CODE.US },
  { code: '46', name: 'Montana', stateCode: 'MT', countryCode: COUNTRY_CODE.US },
  { code: '47', name: 'Nebraska', stateCode: 'NE', countryCode: COUNTRY_CODE.US },
  { code: '48', name: 'Nevada', stateCode: 'NV', countryCode: COUNTRY_CODE.US },
  { code: '49', name: 'New Hampshire', stateCode: 'NH', countryCode: COUNTRY_CODE.US },
  { code: '50', name: 'New Jersey', stateCode: 'NJ', countryCode: COUNTRY_CODE.US },
  { code: '51', name: 'New Mexico', stateCode: 'NM', countryCode: COUNTRY_CODE.US },
  { code: '52', name: 'New York', stateCode: 'NY', countryCode: COUNTRY_CODE.US },
  { code: '53', name: 'North Carolina', stateCode: 'NC', countryCode: COUNTRY_CODE.US },
  { code: '54', name: 'North Dakota', stateCode: 'ND', countryCode: COUNTRY_CODE.US },
  { code: '55', name: 'Ohio', stateCode: 'OH', countryCode: COUNTRY_CODE.US },
  { code: '56', name: 'Oklahoma', stateCode: 'OK', countryCode: COUNTRY_CODE.US },
  { code: '57', name: 'Oregon', stateCode: 'OR', countryCode: COUNTRY_CODE.US },
  { code: '59', name: 'Pennsylvania', stateCode: 'PA', countryCode: COUNTRY_CODE.US },
  { code: '60', name: 'Puerto Rico', stateCode: 'PR', countryCode: COUNTRY_CODE.US },
  { code: '61', name: 'Rhode Island', stateCode: 'RI', countryCode: COUNTRY_CODE.US },
  { code: '62', name: 'South Carolina', stateCode: 'SC', countryCode: COUNTRY_CODE.US },
  { code: '63', name: 'South Dakota', stateCode: 'SD', countryCode: COUNTRY_CODE.US },
  { code: '64', name: 'Tennessee', stateCode: 'TN', countryCode: COUNTRY_CODE.US },
  { code: '65', name: 'Texas', stateCode: 'TX', countryCode: COUNTRY_CODE.US },
  { code: '66', name: 'Utah', stateCode: 'UT', countryCode: COUNTRY_CODE.US },
  { code: '67', name: 'Vermont', stateCode: 'VT', countryCode: COUNTRY_CODE.US },
  { code: '68', name: 'Virginia', stateCode: 'VA', countryCode: COUNTRY_CODE.US },
  { code: '69', name: 'Washington', stateCode: 'WA', countryCode: COUNTRY_CODE.US },
  { code: '70', name: 'West Virginia', stateCode: 'WV', countryCode: COUNTRY_CODE.US },
  { code: '71', name: 'Wisconsin', stateCode: 'WI', countryCode: COUNTRY_CODE.US },
  { code: '72', name: 'Wyoming', stateCode: 'WY', countryCode: COUNTRY_CODE.US },
  { code: '73', name: 'Virgin Islands (US)', stateCode: 'VI', countryCode: COUNTRY_CODE.US },
] as const

export const ALL_PROVINCES = [...CANADIAN_PROVINCES, ...US_STATES] as const

export type TCanadianProvince = (typeof CANADIAN_PROVINCES)[number]
export type TUSState = (typeof US_STATES)[number]
export type Country = (typeof COUNTRIES)[number]
export type TProvinceOrState = TCanadianProvince | TUSState

export function getProvincesByCountry(countryCode: string) {
  switch (countryCode) {
    case COUNTRY_CODE.CA:
      return CANADIAN_PROVINCES
    case COUNTRY_CODE.US:
      return US_STATES
    default:
      return []
  }
}

/**
 * Checks if a province code is valid for a given country
 * @param provinceCode - The province/state code to validate
 * @param countryCode - The country code to check against
 * @returns true if the province is valid for the country, false otherwise
 */
export function isValidProvinceForCountry(
  provinceCode: string | undefined,
  countryCode: string
): boolean {
  if (!provinceCode) return true // Empty province is always valid

  const provinces = getProvincesByCountry(countryCode)
  return provinces.some((p) => p.code === provinceCode)
}

export const getCountryByProvince = (provinceCode: string): Country | null => {
  const canadianProvince = CANADIAN_PROVINCES.find(({ code }) => code === provinceCode)
  if (canadianProvince) {
    return COUNTRIES.find(({ code }) => code === COUNTRY_CODE.CA) ?? null
  }

  const usState = US_STATES.find(({ code }) => code === provinceCode)
  if (usState) {
    return COUNTRIES.find(({ code }) => code === COUNTRY_CODE.US) ?? null
  }

  return null
}

/**
 * Gets the province/state name by its code from ALL_PROVINCES
 * @param provinceCode - The province/state code to look up
 * @returns The province name if found, undefined otherwise
 */
export function getProvinceNameByCode(provinceCode: string | undefined): string | undefined {
  if (!provinceCode) return undefined
  const province = ALL_PROVINCES.find((p) => p.code === provinceCode)
  return province?.name
}

export const VALID_CANADIAN_POSTAL_CODE_REGEX = /^[A-Z]\d[A-Z][ ]?\d[A-Z]\d$/

export const VALID_US_ZIP_CODE_REGEX = /^\d{5}$/
